var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"map",staticClass:"map",on:{"click":function($event){return _vm.resetAll()},"mousedown":_vm.startDrag,"mouseup":_vm.endDrag,"mouseleave":_vm.endDrag,"mousemove":_vm.onDrag,"mousewheel":_vm.onWheel,"DOMMouseScroll":_vm.onWheel}},[_c('inline-svg',{class:[
			{ 'garden': this.currentMap === 'gardens' },
			{ 'interior': this.currentMap === 'main' },
			{ 'lobby': this.screen === 'lobby' },
			{ 'stairwell': this.screen === 'stairwell' },
			{ 'selected': this.mapSelected === true },
			{ 'highlightStart': this.highlightStartPoint === true },
			{ 'interior-visible': this.interiorZoomThreshold === true },
			{ 'outdoor-path-hidden': this.outdoorPath !== true },
			{ 'map-visible': this.mapVisible === true },
			{ 'emergency-exits-visible': this.emergencyExitsVisible === true }
		],attrs:{"id":"svgMap","src":_vm.mapImage},on:{"loaded":function($event){return _vm.svgLoaded($event)}}}),_vm._v(" "),_c('MapLabels',{attrs:{"zoomFactor":this.zoomFactor,"mapLoaded":this.mapLoaded,"lastSelected":this.lastPrefix},on:{"selectLabel":_vm.onLabelSelected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }